module.exports = __webpack_public_path__ + "static/media/3 11 Tulleord Peano er feil.e0ae13d3.mp3";